// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Manrope_538739', '__Manrope_Fallback_538739'","fontStyle":"normal"},"className":"__className_538739","variable":"__variable_538739"};